<template>
  <div
    :class="{ hide: !isOnStorePage, 'reward-program pd5 flex-row': true }"
    v-bind:style="{border: `1px solid ${modulePropsData?.themeColor}`}"
    @click="handleClick($event)"
    v-if="
      isLoggedIn &&
      getUserData?.rewardType &&
      rewardTypeEligibleInCurrentStore &&
      getRewardIconPath
    "
  >
    <VueLottiePlayer
      name="homeStepper"
      width="100%"
      height="100%"
      loop="3"
      :animationData="require('../assets/home-stepper-dark.json')"
      v-if="!getUserData.isEnrolled && isThemificationEnabled"
    />
    <VueLottiePlayer
      name="homeStepper"
      width="100%"
      height="100%"
      loop="3"
      :animationData="require('../assets/home-stepper.json')"
      v-if="!getUserData.isEnrolled && !isThemificationEnabled"
    />
    <div
      class="reward-icon"
      v-bind:style="{
        backgroundImage: `url('` + getRewardIconPath + `')`,
        height: getUserData.rewardData.elizibleForPizza ? '21px' : '20px',
      }"
      v-if="getUserData.isEnrolled"
    >
      <p 
        class="bold" 
        v-if="getUserData.rewardData.elizibleForPizza"
        v-bind:style="{color: modulePropsData?.themeColor}"
      >
        {{
          Math.floor(
            getUserData.rewardData.points / getUserData.rewardData.maxPoints
          )
        }}
      </p>
    </div>

    <span 
      class="reward-name bold fs-10 lh11" 
      v-html="getRewardIconText"
      v-bind:style="{color: modulePropsData?.themeColor}"
    ></span>
  </div>
</template>

<script>
import { keyMapsGetter } from "../helpers/storeKeys";
import { 
  v2PwaBasePath,
  themificationEnabled
} from "../config/apiEndpoints";
import Utility from "../helpers/utility";
import setEvents, { updateAmplitudeUserProperties } from "../helpers/events";
import { defineAsyncComponent } from "vue";

export default {
  name: "RewardProgram",

  components: {
    VueLottiePlayer: defineAsyncComponent(() => import("vue-lottie-player")),
  },
  props:["moduleProps"],
  data() {
    return {
      isOnStorePage: window.location.href.includes(
        Utility.getCurrentStoreFolder()
      ),
      modulePropsData: {}
    };
  },
  mounted() {
    this.modulePropsData = this.moduleProps || {};
  },
  methods: {
    handleClick(event) {
      if (this.getUserData?.rewardType == "CHEESY") {
        //Amplitude click event load
        const preEventObj = { category: "cheesyrewards" };
        const eventObj = Utility.amplitudeEventObj(
          "click",
          "topbar",
          "1",
          preEventObj
        );
        if(this.getUserData?.isEnrolled) {
          const rewardPoints = this.getUserData?.rewardData?.points;
          updateAmplitudeUserProperties({ reward_points: rewardPoints });
        }
        setEvents("amplitude", "Click", eventObj);
        window.location.href = `${v2PwaBasePath}/${window?._siteProps_?.props?.postorderUIBasepath}pizzaLoyalty`;
      } else {
        window.location.href = v2PwaBasePath + "/pizza-pal";
      }
    }
  },

  computed: {
    isLoggedIn() {
      return this.$store.state.Auth.isLoggedIn;
    },
    getRewardIconText() {
      return this.$store.getters[keyMapsGetter.GET_REWARD_ICON_TEXT];
    },
    getRewardIconPath() {
      return this.$store.getters[keyMapsGetter.GET_REWARD_ICON_PATH];
    },
    getUserData() {
      return this.$store.getters[keyMapsGetter.GET_USER_DATA];
    },
    rewardTypeEligibleInCurrentStore() {
      let userData = this.$store.getters[keyMapsGetter.GET_USER_DATA];
      let storeDetails = this.$store.state.Location.storeDetails;
      if (userData?.rewardType == "PIZZAPAL") {
        return true;
      }
      if (userData?.rewardType == "CHEESY") {
        if (
          storeDetails?.loyaltyProgramCodes?.includes("POTP1") ||
          storeDetails?.loyaltyProgramCodes?.includes("POTP2")
        ) {
          return true;
        }
      }
      return false;
    },
    isThemificationEnabled() {
      if(themificationEnabled) {
        return true;
      }
      return false;
    }
  },
};
</script>

<style scoped></style>
